import React, { Component } from 'react';
import { connect } from "react-redux";
import { CookieWrap as Cookies } from "../helper/cookie-wrap";
import { css_file_to_url } from "../helper/css-util";
import { getRGB } from "../../lib/color";
import { USER, DEVICE_WIDTH } from "../../lib/constants";
import { navigatePath } from "../nav/actions";
import { BannerMenu } from "../components/BannerMenu/BannerMenu";
import {HamburgerIcon, Spinner} from "../funcs/utils";
import {logUserEvent} from "./actions";
import {dispatch_logout} from "./logout-dispatch";
import {HeaderLut} from "./header_bars/header_lut";
import {UserEvents} from "../../lib/user-events";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOn: false,
      loggingOut: false,
    };
  }

  componentDidMount() {
    if (this.props.do_logout) {
      this.logOut("/");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.hideMenu();
  }

  toggleMenu = () => {
    let burger = document.querySelector(".burger");
    let menu = document.querySelector(".navbar-menu");
    burger.classList.toggle("is-active");
    menu.classList.toggle("is-active");
    this.setState({ menuOn: !this.state.menuOn });
  };

  hideMenu = () => {
    let burger = document.querySelector(".burger");
    let menu = document.querySelector(".navbar-menu");

    if(!menu) return;

    burger.classList.remove("is-active");
    menu.classList.remove("is-active");
    this.setState({ menuOn: false });
  };

  logOut = (new_path) => {

    this.props.logout();
    const username = this.props.user && this.props.user.username;

    this.setState({ loggingOut: true });
    logUserEvent(__filename, UserEvents.LOGOUT, { username })
      .then(() => {
        this.setState( { loggingOut: false });
        // Handle Logout
        const cookies = new Cookies();
        cookies.remove('token', { path: '/' });
        cookies.remove('access', { path: '/' });
        cookies.remove('refresh', { path: '/' });
        cookies.remove('user_wlf_id', { path: '/' });
      });
    this.props.navigatePath("/login");
  };

  rightMenuClick = (ev) => {
    if (this.do_medium_layout()) {
      BannerMenu.instance.toggleHamburgerMenu(ev)
    } else {
      this.logOut();
    }
  }

  onLogoClick = () => {
    const wlf = this.props.app.wlf;
    if (wlf.ui && wlf.ui.logo_url) {
      if (wlf.ui.logo_url !== "DISABLED") {
        window.location.href = wlf.ui.logo_url;
      }
      return;
    }

    if (!this.props.isLoggedIn) {
      this.props.navigatePath("/login");
    } else if (this.props.account_type === USER) {
      const url = "/user?acct_index=" + this.props.loaded_acct_index.toString();
      this.props.navigatePath(url);
    }
  };

  maybeRenderLogo = () => {
    const logo = this.props.client.logo;
    if (!logo) {
      return null;
    }

    const style = {
      maxHeight: "5rem",
      marginTop: "1rem",
      marginLeft: "6rem",
    };
    if (this.do_small_layout()) {
      style.maxHeight = "3rem";
      style.marginLeft = "2rem";
    }

    const logo_url = css_file_to_url(this.props.config, logo);
    return (
      <img
        className="logo-img-responsive"
        src={logo_url}
        style={style}
        alt="Logo"
        onClick={this.onLogoClick}/>
    );
  };

  do_medium_layout = () => {
    return this.props.app.width <= DEVICE_WIDTH.large;
  }

  do_small_layout = () => {
    return this.props.app.width <= DEVICE_WIDTH.medium;
  }

  getPath = () => {
    return this.props.location.pathname;
  }

  maybeRenderHeaderBar = () => {
    return null;
  }

  maybeRenderEndBar = () => {
    const wlf_ui = this.props.app.wlf.ui;
    if (!wlf_ui) {
      return null;
    }

    // Logged in UI
    if (this.props.isLoggedIn) {
      return null;
    }

    // Logged out UI
    const path = this.getPath();
    if (path === "/offerings") {
      if (wlf_ui.signed_out_offerings_endbar && HeaderLut[wlf_ui.signed_out_offerings_endbar]) {
        const func = HeaderLut[wlf_ui.signed_out_offerings_endbar];
        return func({ component: this});
      }
    }

  }

  render() {

    if (this.props.do_logout || this.props.location.pathname === '/') {
      // Show nothing if we're in the WLF selector
      return null;
    }

    // No header for BD apps
    if (this.props.app.wlf.apps && this.props.app.wlf.cd_explorer) {
      if (this.getPath().startsWith("/cds/offerings")) {
        return null;
      }
    }

    const text_color = getRGB(this.props.client.color.sign_on_button);
    const a_style = {
      marginTop: "1rem",
      color: text_color,
      fontSize: "1.5rem",
      fontWeight: "400",
    };
    const right_container_style = {
      paddingRight: this.do_medium_layout() ? "0" : "7rem",
    }
    const {isLoggedIn} = this.props;


    const logout = this.state.loggingOut
      ? <span style={{paddingRight: "2rem"}}><Spinner/></span>
      : "Log Out";
    const right_menu = this.do_medium_layout()
      ? (<HamburgerIcon/>)
      : (<span>{logout}</span>);
    const is_small = this.do_small_layout();
    const nav_style = {};
    if (is_small) {
      nav_style.padding = "0";
    }
    return (
      <div>
        <nav
          style={nav_style}
          className="header-container-responsive"
          aria-label="main navigation">
          <div className="navbar-container-responsive">
            <a className="navbar-logo-responsive">
              { this.maybeRenderLogo() }
            </a>
          </div>

          <div>
            { this.maybeRenderHeaderBar() }
          </div>
          <div className="navbar-end-responsive" style={right_container_style}>
            {isLoggedIn && <div className="navbar-item-responsive">
              <a className="log-out-btn" onClick={this.rightMenuClick} style={a_style}>
                { right_menu }
              </a>
            </div>}
            { !is_small && this.maybeRenderEndBar() }
          </div>
        </nav>
        <div style={{ display: "flex", justifyContent: "center" }}>
          { is_small && this.maybeRenderEndBar() }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    navigatePath: (path, args) => { dispatch(navigatePath(path, args)) },
    logout: () => { dispatch_logout(dispatch) },
  }
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: !!((state.user && state.user.token)
      || (state.user && state.user.onboarding_token)),
    client: state.client,
    app: state.app,
    config: state.app.config,
    user: state.user,
    account_type: state.user && state.user.account_type,
    loaded_acct_index: state.user && state.user.loaded_acct_index,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
